import Vue from 'vue';
import router from './router';
import { Localization } from '@/services/localization';
import i18n from '@/i18n';
import { fromDerivedStage } from '@/util/stageUtil';
import { HckClient } from './client/HckClient';
import { brandContext } from './constants/locales';
const App = () => {
  switch (brandContext) {
    case 'Cupra':
      return import('./AppCupra.vue');
    case 'Volkswagen':
      return import('./AppVolkswagen.vue');
    default:
      return import('./AppAudi.vue');
  }
};

Vue.config.ignoredElements = [/^abi-/];
Vue.config.productionTip = false;

Vue.prototype.$digitalGiveawayClient = new HckClient(fromDerivedStage(new URL(window.location.href).hostname));

Vue.prototype.$localization = new Localization();

console.log('Initializing App for Brand: ' + `[${brandContext}]`);
new Vue({
  router,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
